import React from 'react';
import { Box, Typography, Chip, Paper } from '@mui/material';

interface SelectedTicketTypesProps {
  selectedTicketTypes: string[];
}

export const SelectedTicketTypes: React.FC<SelectedTicketTypesProps> = ({ 
  selectedTicketTypes 
}) => {
  if (!selectedTicketTypes || selectedTicketTypes.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500, color: '#34495e' }}>
        Selected Ticket Types
      </Typography>
      <Paper 
        variant="outlined" 
        sx={{ 
          p: 0.75, 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 0.5,
          backgroundColor: '#f8f9fa'
        }}
      >
        {selectedTicketTypes.map((type) => (
          <Chip 
            key={type} 
            label={type} 
            color="primary" 
            variant="outlined"
            size="small"
            sx={{ fontWeight: 500, height: '24px', '& .MuiChip-label': { px: 0.75, fontSize: '0.75rem' } }}
          />
        ))}
      </Paper>
    </Box>
  );
};